import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { ToastContainer, toast } from 'react-toastify';
import withAuth from '../components/authHOC';
import { Card, Col } from 'react-bootstrap';
import { Alert, Button, Form, Input, InputNumber, Select} from 'antd';
import { IClient, IClientAccount, IGuarantor, IIdType, ILoan, ISaving, ISecurityType} from '../factory/interfaces';
import { AUTH_URL } from '../constants';
import axios from 'axios';
import { SearchOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';


export  const notify = (message: string, style: any) => toast.error(message, {
        style
        })
    //Toaster
export    const toastStyle: any =  {
        background: '#ffffff',
        color: '#0a0a0a',
        fontSize: "13px",
        padding: '2px',
        position: 'bottom-center',
        fontStyle: 'bold'
      }

export const notify_success = (message: string, style: any) => toast.success(message, {
        style
        })

export interface loginCredentials{
        email: string,
        password: string
    }

const NewSavingForm = () => {

  const [saving, setSaving]= useState<ISaving>()
  const [securityTypes, setSecurityTypes]= useState<ISecurityType[]>()
  const [idTypes, setIdTypes]= useState<IIdType[]>()
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = useState(false)
  const [client, setClient]= useState<IClient>()
  const [clientAccount, setClientAccount] = useState<IClientAccount>()
  const [searchIdType, setSearchIdType] = useState<string | undefined>()
  const [searchId, setSearchId] = useState<string | undefined>()
  const [searching, setSearching]= useState(false)
  const [searchedClient, setSearchedClient]= useState(false)
  const [submittingSaving, setSubmittingSaving]= useState(false)
  const [guarantors, setGuarantors]= useState<IGuarantor[]>([
    {name: '' , phone: '', address: ''},
    {name: '' , phone: '', address: ''}

    ])

  const componentRef = useRef(null)

  const metadata = useSelector((state: any) => state.metadata)

  useEffect(() => {
    if (metadata?.data?.meta_data?.id_types) {
      setIdTypes(metadata.data.meta_data.id_types)
    }
  }, [metadata])


  //Submit

  const submit = async ()=>{
    setSubmittingSaving(true)
    const savingData ={
      client: client?._id,
      amount: saving?.amount

    }
    const response  = await axios.post(`${AUTH_URL}/finances/savings`, savingData, {withCredentials: true})
    setSubmittingSaving(false)
    if(response.data.success){
      notify_success('Saving has been registered successfully', toastStyle)
      form.resetFields()
    }else{
      notify(`${response.data.message}`, toastStyle)
    }
  }

const handleFindClient = async()=>{

  try {
  setSearching(true)
  const response = await axios.post(`${AUTH_URL}/clients/find`, {id_type: searchIdType, id_number: searchId}, {withCredentials: true})
  setSearching(false)
  if(response.data.client){
    setClient(response.data.client)
    setClientAccount(response.data.client_account)

  }
  
  if(!response.data.success){
    notify(`${response.data.message}`, toastStyle)
  }

    
  } catch (error: any) {
    notify(error.message, toastStyle)
    setSearching(false)
    
  }

}

const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});


  return (
    <Container ref={componentRef} fluid id='users-container'>
        <Row className=' justify-content-center py-0 g-0'>
    <ToastContainer position="top-center" className='text-capitalize'/>
        </Row>
        <Row>
        <Col>
         <Card className='p-2 rounded-0'>
                <Form
                className='p-3'
                  layout="vertical"
                  form={form}
                  name="control-hooks"
                  onFinish={submit}

                    >
                    <Row className='p-3  border'>
                    <h5>Client details</h5>

                    { client ?
                    <>
                     <Col>
                     <Form.Item 
                    label="Surname" 
                    name="surname"
                    initialValue={client.surname}
                    >
                        <Input 
                          readOnly
                         />
                    </Form.Item>
                    <Form.Item label="Given name"
                    name="given_name"
                    initialValue={client.given_name}
                    >
                        <Input
                         readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     
                    <Form.Item 
                    label="Gender"
                    name="gender"
                    initialValue={client.gender}
                    >
                        <Input 
                          readOnly
                         />
                    </Form.Item>
                     <Form.Item 
                      label="Phone"
                      name="phone"
                      initialValue={client.phone}
                      >
                        <Input
                          readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                    label="Email"
                    name="email"
                    initialValue={client.email}
                    >
                        <Input 
                          readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                    label="Branch"
                    name="branch"
                    initialValue={client.branch}
                    >
                        <Input 
                          readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                      <Form.Item
                        label="Id type"
                        name="id_type"
                        initialValue={client.id_type}
                        >
                        <Input 
                            readOnly
                          />
                      </Form.Item>
                      <Form.Item 
                      label="ID Number"
                      name="id_number"
                      initialValue={client.id_number}
                      >
                          <Input 
                            readOnly
                          />
                      </Form.Item>
                    
                    </Col>
                    </>:
                    <Row className='align-items-center'>
                    <Col>
                    <Form.Item 
                      label="Client ID type"
                      name="search_id_type"
                      rules={[{required: true, message: 'ID types search context is required'}]}
                      >
                        <Select
                        allowClear
                        placeholder="Select ID type"
                        style={{ width: '100%' }}
                        options={idTypes?.map((type) => ({
                          value: type._id,
                          label: type.name,
                        }))}
                        onChange={(value) =>
                            setSearchIdType(value)
                         }
                      />
                      </Form.Item>
                      
                    </Col>
                    <Col>
                    <Form.Item 
                      label="ID Number"
                      name="search_id_number"
                      rules={[{required: true, message: 'Please provide the client ID number'}]}
                      >
                       <Input
                       onChange={(e)=>setSearchId(e.target.value)}
                       />
                      </Form.Item>
                      
                    </Col>
                    <Col>
                    <Button
                     className='rounded-0 text-uppercase' 
                     type='primary'
                     onClick={handleFindClient}
                     loading={searching}
                     > <SearchOutlined>
                      </SearchOutlined> 
                      {
                        searching ?
                      'Finding client...'
                      :
                      'Find Client'

                      }
                      
                      </Button>
                    
                    </Col>
                    
                    
                    </Row>

                    }
                   
                    {
                      (client) &&

                        <Row className='p-3 my-3 border'>
                    <h5>Saving details</h5>
                    <Row>

                      <Col>
                        <Form.Item
                          label="Current Saving Balance"
                          name="amount"
                          initialValue={clientAccount?.current_savings_amount}
                        >
                          <Input readOnly
                            
                            />
                         </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item
                            label="Enter amount to save"
                            name="saving_amount"
                           >
                            <InputNumber
                             style={{width: '100%'}}
                             className='rounded-0'
                                onChange={(value) => {
                                    setSaving((prevLoanData: any) => ({
                                        ...prevLoanData,
                                        amount: value,
                                    }));
                                }}
                            />
                          </Form.Item>
                        </Col>
                    </Row>
                    </Row>
                    }
                  </Row>
                    
                    <Row>
                    <Col className='my-3'>

                     {
                      (client) &&
                      <>
                      <Button loading={submittingSaving} type="primary" htmlType="submit" className='rounded-0 text-uppercase'>
                      {

                        submittingSaving ?
                      'Registering saving...' :
                      'Register Saving'
                      }
                     </Button>
                       <Button onClick={handlePrint} className='rounded-0 mx-3 text-uppercase'>Print Saving Receipt</Button>
                      
                      </>
                     }
                    
                    
                    </Col>
                     
                  </Row>
                  
                </Form>
            </Card>
        
        
        </Col>
        
        </Row>
    </Container>
  )
}

export default withAuth (NewSavingForm, ['admin', 'agent'])
